import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavigateFunction } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { getDiffConfigs } from '@/features/_data/useUpdateConfigs';
import { IconArrowLeft } from '@/icons';
import { Button } from '@/ui/Button/Button';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';

import { ConfigMap } from '../AdminEditPage';

const StyledBackButton = styled(Button)`
  width: 32px;
  height: 32px;
`;

const StyledSaveButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}
`;

type Props = {
  readonly configState: ConfigMap;
  readonly data: ConfigMap;
  readonly handleSave: () => void;
  readonly loading: boolean;
  readonly navigate: NavigateFunction;
};

export const TopBar = ({
  configState,
  data,
  handleSave,
  loading,
  navigate,
}: Props) => {
  const {
    createdSubsidiaries,
    deletedSubsidiaries,
    updatedSubsidiaries,
    createdShelves,
    deletedShelves,
    updatedShelves,
    createdPlayers,
    deletedPlayers,
    updatedPlayers,
  } = getDiffConfigs(data, configState);

  const hasChanged =
    Boolean(createdSubsidiaries.length) ||
    Boolean(deletedSubsidiaries.length) ||
    Boolean(updatedSubsidiaries.length) ||
    Boolean(createdShelves.length) ||
    Boolean(deletedShelves.length) ||
    Boolean(updatedShelves.length) ||
    Boolean(createdPlayers.length) ||
    Boolean(deletedPlayers.length) ||
    Boolean(updatedPlayers.length);

  return (
    <Flex align="center" justify="space-between">
      <Flex align="center" gap={8}>
        <StyledBackButton mode="secondary" onClick={() => navigate('/')}>
          <IconArrowLeft />
        </StyledBackButton>
        <T h1>
          <FormattedMessage defaultMessage="Admin Edition Page" id="FA0eP9" />
        </T>
      </Flex>
      <StyledSaveButton
        disabled={loading || !hasChanged}
        loading={loading}
        onClick={handleSave}
        size="large"
      >
        <FormattedMessage defaultMessage="Save" id="jvo0vs" />
      </StyledSaveButton>
    </Flex>
  );
};
